import React from 'react';

const Lock = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 11 14" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path
        id="Lock_a"
        d="M860.33 1508.51c-.73 0-1.33.6-1.33 1.33v5.83c0 .73.6 1.33 1.33 1.33h8c.74 0 1.34-.6 1.34-1.33v-5.83c0-.73-.6-1.33-1.34-1.33zm4 5.32a1.5 1.5 0 0 1-1.49-1.5 1.5 1.5 0 0 1 2.99 0c0 .83-.68 1.5-1.5 1.5z"
      />
      <path id="Lock_b" d="M862.27 1507.76v-1.43a2.07 2.07 0 0 1 4.13 0v1.43h1.27v-1.43a3.33 3.33 0 0 0-6.67 0v1.43z" />
    </defs>
    <use fill="currentColor" xlinkHref="#Lock_a" transform="translate(-859 -1503)" />
    <use fill="currentColor" xlinkHref="#Lock_b" transform="translate(-859 -1503)" />
  </svg>
);

export default Lock;



// WEBPACK FOOTER //
// ./src/common/icons/Lock.js